/*
 * Confirms the discount the "Apply" link in the welcome popup just set.
 * That link redirects to Shopify's own /discount/<code> route, which lands
 * the shopper on "shop now" with our own ?discount_applied=<code> param -
 * this reads it, shows the banner, then cleans the URL so a refresh or a
 * bookmark of that page never shows it again.
 */
if (!window.discountAppliedBannerLoaded) {
  window.discountAppliedBannerLoaded = true;

  const params = new URLSearchParams(window.location.search);
  const code = params.get('discount_applied');

  if (code) {
    const banner = document.getElementById('DiscountAppliedBanner');
    const textNode = banner?.querySelector('[data-discount-applied-text]');

    if (banner && textNode) {
      // Localized in sections/promo-popup.liquid (setting, else locale key).
      const template = banner.dataset.messageTemplate || '';
      textNode.textContent = template.replace('[code]', code);

      banner.hidden = false;
      requestAnimationFrame(() => banner.classList.add('discount-applied-banner--visible'));

      window.setTimeout(() => {
        banner.classList.remove('discount-applied-banner--visible');
        window.setTimeout(() => {
          banner.hidden = true;
        }, 300);
      }, 4000);
    }

    params.delete('discount_applied');
    const query = params.toString();
    const cleanUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);
  }
}
